export const brandsFilter = {
  init: () => {
    brandsFilter.filter_handle();
    brandsFilter.form_handle();
  },
  filter_handle: (search_bar) => {
    const alphaFilters = document.querySelectorAll('.alphabetical--filter button');

    [...alphaFilters].map(button => {
      const listing = document.querySelector(
        search_bar ? `.brands--listing[id="${button.dataset.scrollto}"] ul li:not(.hidden)`
          : `.brands--listing[id="${button.dataset.scrollto}"] ul`);

      button.classList.toggle('disabled', !listing);
      button.setAttribute('aria-disabled', !listing);
      button.dataset.left = button.getBoundingClientRect().left;
    });

    window.addEventListener('scroll', () => {
      [...alphaFilters].map((button, index) => {
        const listing = document.querySelector(`.brands--listing[id="${button.dataset.scrollto}"]`);
        const rect = listing.getBoundingClientRect();
        const offset = window.headerHeight + window.filtersHeight + (window.bannerHeight || 0) ;


        if (listing && !button.classList.contains('disabled')) {
          if (rect.top <= offset) {

            const button_is_active = button.classList.contains('active');
            const active = document.querySelector('.alphabetical--filter button.active');

            if (!button_is_active && rect.bottom >= offset) {
              const cat_filter = document.querySelector('.alphabetical--filter');
              active?.classList.remove('active');
              active?.removeAttribute('aria-current');

              button.classList.add('active');
              button.setAttribute('aria-current', true);

              if (window.is_mobile) {
                cat_filter.scrollTo(parseFloat(button.dataset.left), 0);
              }
            }
          }
        }
      });
    });
  },
  form_handle: () => {
    const form = document.querySelector('.form--search[data-search=brands]');

    if (form) {
      form.addEventListener('submit', e => {
        e.preventDefault();
        e.stopPropagation();
      });

      const input = form.querySelector('input');
      input.addEventListener('keyup', () => {
        const items = document.querySelectorAll(`.brands--listing li`);
        [...items].map(item => {
          item.classList.toggle('hidden', !item.innerText.toLowerCase().includes(input.value.toLowerCase()));
        });

        if (input.value !== '') {
          const no_brands = document.querySelector('.section--brands .search--no-results strong');
          no_brands.innerText = input.value;
          brandsFilter.filter_handle(true);
        }
        else {
          brandsFilter.filter_handle();
        }

        const brands_number = document.querySelectorAll(`.brands--listing li:not(.hidden)`).length
        const brands_section = document.querySelector(`.section--brands`);

        brands_section.setAttribute('aria-label', `${brands_number} marque${brands_number > 1 ? 's' : ''} trouvée${brands_number > 1 ? 's' : ''}`)
      });

      formsHandle.reset(form);
    }
  },
};

export const searchForm = {
  init: () => {
    searchForm.form_keyup();
    searchForm.previous_search();
  },
  form_keyup: () => {
    //TODO: fetch search results
    const form = document.querySelector('.header--search .form--search');
    const results_wrapper = document.querySelector('.search--result ul');

    if (form) {
      const input = form.querySelector('input[name=s]');
      let tm = null;

      input.addEventListener('keyup', () => {
        form.classList.add('form--searching');

        if (tm !== null) {
          clearTimeout(tm);
        }

        tm = setTimeout(async () => {
          //const search = await fetch('/wp-json/wp/v2/search?search='+input.value)

          if (input.value !== '') {
            const lang = document.querySelector('html').dataset.lang;

            const results = await fetch('/wp-json/search/v1/get', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                search: input.value,
                lang: lang
              }),
            }).then(resp => resp.text());

            results_wrapper.innerHTML = results;
            form.classList.remove('form--searching');
          }
          else {
            results_wrapper.innerHTML = '';
            form.classList.remove('form--searching');
          }

          tm = null;
        }, 300);

      });
    }
  },

  /* *
   * previous_search : Fonction de récupération et de sauvegarde des recherches précédentes dans les local storages
   * */

  previous_search: () => {
    // On récupère les recherches depuis le local storage, si inexistant on retourne un tableau vide.
    const previous_searches = localStorage.getItem('searches')?.split(';') || [];

    // On vérifie bien qu'on est sur la page des résultats de recherche
    const search_page = document.querySelector('.search');
    if (search_page) {
      // On stocke la valeur de la recherche actuelle
      // IMPORTANT : le dataset "data-search", n'est renseigné dans la section que si des éléments sont remontés dans le résultat de recherche
      const current_search = document.querySelector('[data-search]')?.dataset.search;

      // Si on récupère bien une valeur de recherche actuelle, et si celle-ci ne figure pas déjà dans les recherches précédentes sauvegardées.
      if (current_search && !previous_searches.includes(current_search)) {
        previous_searches.push(current_search); // Ajout de la recherche dans le tableau
        previous_searches.reverse(); // On inverse le tableau

        // On limite le nombre de valeur à 5
        if (previous_searches.length > 5) {
          previous_searches.splice(4, 1);
        }

        // Sauvegarde des recherches dans le localStorage
        localStorage.setItem('searches', previous_searches.join(';'));
      }
    }

    // Rendu de la liste UL
    searchForm.update_previous(previous_searches);
  },

  /* *
   * update_previous : Fonction de mise à jour de la liste UL des recherches précédentes
   * Params: previous_search_array (tableau avec les recherches à afficher)
   * */

  update_previous: (previous_search_array) => {
    const lang = document.querySelector('html').dataset.lang;
    const previous_search_listing = document.querySelector('.search--latest ul');
    // On vide la liste UL
    previous_search_listing.innerHTML = '';

    previous_search_array.map((item, index) => {
      // Création de l'item de liste
      const list_item =
        `<li class="tag--searchbar"><a href="/${lang}/recherche/${item}" class="hover-underline">${item}</a><button>Supprimer</button></li>`;
      previous_search_listing.innerHTML += list_item;
    });

    // Gestion de la suppression de la valeur de recherche au click sur le bouton X
    [...previous_search_listing.querySelectorAll('button')].map((button, index) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // On récupère les recherches dans le localStorage
        const previous_searches_updated = localStorage.getItem('searches')?.split(';') || [];
        previous_searches_updated.splice(index, 1); // Suppression de l'occurence

        if (previous_searches_updated.length > 0) { // Si le tableau final n'est pas vide on re-sauvegarde
          localStorage.setItem('searches', previous_searches_updated.join(';'));
        } else { // Sinon on supprime carrément la variable dans la localStorage
          localStorage.removeItem('searches');
        }

        // On remet à jour la liste UL
        searchForm.update_previous(previous_searches_updated);
      });
    });
  },
};

const formsHandle = {
  reset: (form, callback = null) => {
    const reset = form.querySelector('button[type=reset]');
    reset.addEventListener('click', () => {
      const input = form.querySelector('input');
      input.value = '';
      const keyupEvent = new Event('keyup');
      input.dispatchEvent(keyupEvent);
      brandsFilter.filter_handle();

      if (callback) {
        callback();
      }
    });
  },
};
